import createIcon from '../../createIcon';

/**
 * @component @name SolarPower
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMy4zMyAxNkgxMVYxM0g0TDMuMzMgMTZaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTMgMTZIMjAuNjdMMjAgMTNIMTNWMTZaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjEuMTEgMThIMTNWMjJIMjJMMjEuMTEgMThaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMiAyMkgxMVYxOEgyLjg5TDIgMjJaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTMgOEgxMVYxMUgxM1Y4WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE3LjE3ODcgNS43OTA5NkwxNS43NjQ1IDcuMjA1MTZMMTcuODg1OCA5LjMyNjQ2TDE5LjMgNy45MTIyNkwxNy4xNzg3IDUuNzkwOTZaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNNi44MjYxNiA1Ljc5MTQ5TDQuNzA0ODYgNy45MTI3OUw2LjExOTA2IDkuMzI2OTlMOC4yNDAzNiA3LjIwNTY5TDYuODI2MTYgNS43OTE0OVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik02IDJIM1Y0SDZWMloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMSAySDE4VjRIMjFWMloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMiA3QzE0Ljc2IDcgMTcgNC43NiAxNyAySDdDNyA0Ljc2IDkuMjQgNyAxMiA3WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SolarPower = createIcon('SolarPower', [
  ['path', { d: 'M3.33 16H11V13H4L3.33 16Z', key: '1jncjs' }],
  ['path', { d: 'M13 16H20.67L20 13H13V16Z', key: 'wv51ic' }],
  ['path', { d: 'M21.11 18H13V22H22L21.11 18Z', key: 'jig557' }],
  ['path', { d: 'M2 22H11V18H2.89L2 22Z', key: '1lqnxu' }],
  ['path', { d: 'M13 8H11V11H13V8Z', key: 'l88k4z' }],
  [
    'path',
    {
      d: 'M17.1787 5.79096L15.7645 7.20516L17.8858 9.32646L19.3 7.91226L17.1787 5.79096Z',
      key: '1r6390',
    },
  ],
  [
    'path',
    {
      d: 'M6.82616 5.79149L4.70486 7.91279L6.11906 9.32699L8.24036 7.20569L6.82616 5.79149Z',
      key: 'qomhtm',
    },
  ],
  ['path', { d: 'M6 2H3V4H6V2Z', key: '1xs0e8' }],
  ['path', { d: 'M21 2H18V4H21V2Z', key: '11a9z7' }],
  ['path', { d: 'M12 7C14.76 7 17 4.76 17 2H7C7 4.76 9.24 7 12 7Z', key: 'cgk9rm' }],
]);

export default SolarPower;
